// 고객센터 사이드바/드롭다운 공용 메뉴 (모든 고객센터 페이지에서 공유)
export const customerMenus = [
  { label: '공지사항', path: '/notices' },
  { label: '견적문의', path: '/inquiry' },
];
